import { combineReducers } from 'redux'
import { createTransform, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import auth from './auth'
import report from './report'
import reports from './reports'
import resort from './resort'
import users from './users'

// Transform to exclude loading/error states from persistence
const reportTransform = createTransform(
  // transform state on its way to being serialized and persisted
  (inboundState: any) => {
    // Remove loading states before persisting
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { loading, error, errorStack, ...persistedState } = inboundState
    return persistedState
  },
  // transform state being rehydrated
  (outboundState: any) => {
    // Ensure loading states are reset on rehydration
    return {
      ...outboundState,
      loading: false,
      error: false,
      errorStack: undefined
    }
  },
  { whitelist: ['report'] }
)

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'report', 'users', 'reports', 'resort'],
  transforms: [reportTransform]
}

const reducers = combineReducers({
  auth,
  report,
  reports,
  users,
  resort
})

export default persistReducer(persistConfig, reducers)
